module.exports = __webpack_public_path__ + "assets/img/loadfail.2e601b0e.svg";